var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.component)?_c(_vm.component,{tag:"component",attrs:{"device":_vm.device},on:{"deviceClick":function($event){return _vm.$emit('deviceClick', _vm.device)}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }